// NOTE: this file is generated automatically based on app-schemata and should
// not be edited by hand. To update this file, bump the version in the
// APP-SCHEMATA file, run `indy develop` to fetch the appropriate data for
// app-schemata, then run `npm run generate-subclass-mappings` to regenerate
// this file.
export default {
  '50_30_20_budget_module_impression': 'element_impression',
  account_aggregation_page_impression: 'page_impression',
  account_surfaced_element_impression: 'element_impression',
  add_a_bill_impression: 'element_impression',
  add_a_home_address_error_message_impression: 'element_impression',
  add_a_home_address_impression: 'page_impression',
  add_to_compare_interacted: 'element_interacted',
  added_card_impression: 'element_impression',
  ai_match_popup_impression: 'element_impression',
  ai_prefill_error: 'element_impression',
  alert_impression: 'element_impression',
  app_lock_enrollment_changed: 'feature_enrollment_changed',
  approval_odds_element_impression: 'element_impression',
  bcc_page_impression: 'page_impression',
  best_bets_impression: 'product_impression',
  bill_category_impression: 'element_impression',
  bill_detail_impression: 'element_impression',
  bills_enrollment_changed: 'feature_enrollment_changed',
  bills_page_impression: 'page_impression',
  browse_products_impression: 'element_impression',
  card_summary_table_impression: 'element_impression',
  cash_flow_history_month_impression: 'element_impression',
  cash_flow_history_month_interacted: 'element_interacted',
  cash_flow_module_impression: 'element_impression',
  cash_flow_monthly_cash_in_out_chart_impression: 'element_impression',
  cash_flow_monthly_cash_in_out_chart_interacted: 'element_interacted',
  cash_flow_page_impression: 'page_impression',
  cash_flow_transactions_page_impression: 'page_impression',
  category_picker_impression: 'element_impression',
  category_picker_item_impression: 'element_impression',
  cc_navigation_card_category: 'element_impression',
  cc_prequal_page_impression: 'page_impression',
  change_income_estimate_impression: 'element_impression',
  choose_manual_asset_type_impression: 'element_impression',
  choose_manual_property_type_impression: 'element_impression',
  clo_enrollment_changed: 'feature_enrollment_changed',
  clo_page_impression: 'page_impression',
  confirmation_prompt_interacted: 'element_interacted',
  content_element_impression: 'element_impression',
  content_embed_impression: 'element_impression',
  content_impression: 'toplevel_impression',
  content_pack_article_impression: 'content_element_impression',
  content_pack_impression: 'element_impression',
  content_search_page_impression: 'page_impression',
  continuous_onboarding_profile_impression: 'element_impression',
  credit_factor_overview_impression: 'element_impression',
  credit_factor_tip_page_impression: 'page_impression',
  credit_score_enrollment_changed: 'feature_enrollment_changed',
  credit_score_history_impression: 'element_impression',
  credit_score_history_interacted: 'element_interacted',
  credit_score_page_impression: 'page_impression',
  credit_score_summary_impression: 'element_impression',
  custom_spending_category: 'element_impression',
  debt_page_impression: 'page_impression',
  debt_summary_impression: 'element_impression',
  debt_tradeline_overview_impression: 'element_impression',
  delete_all_notifications_interacted: 'element_interacted',
  department_page_impression: 'page_impression',
  distributed_shopping_experience: 'element_impression',
  element_impression: 'impression',
  feature_discovery_prompt_impression: 'element_impression',
  feature_discovery_prompt_interacted: 'element_interacted',
  feature_feedback_interacted: 'element_interacted',
  feature_promotion_impression: 'element_impression',
  feature_value_prop_impression: 'element_impression',
  feed_card_impression: 'content_element_impression',
  financial_account_aggregation_enrollment_changed: 'feature_enrollment_changed',
  financial_account_page_impression: 'page_impression',
  form_impression: 'element_impression',
  geo_page_impression: 'page_impression',
  geo_product_impression: 'product_impression',
  ghost_account_impression: 'element_impression',
  ghost_account_linking_cta_impression: 'element_impression',
  global_nav_impression: 'overlay_impression',
  help_bubble_interacted: 'element_interacted',
  hide_transaction_calculation_element_interacted: 'element_interacted',
  highlight_box_element_impression: 'element_impression',
  home_lead_match_impression: 'element_impression',
  home_ownership_page_impression: 'page_impression',
  home_value_enrollment_changed: 'feature_enrollment_changed',
  ideal_account_balance_tile_impression: 'element_impression',
  institution_link_impression: 'element_impression',
  invalid_form_message_impression: 'element_impression',
  job_page_impression: 'page_impression',
  know_my_wallet_credit_card_tile_impression: 'element_impression',
  know_my_wallet_home_module_impression: 'element_impression',
  link_an_account_impression: 'element_impression',
  link_element_impression: 'element_impression',
  linked_account_checklist_account_impression: 'element_impression',
  linked_account_checklist_module_impression: 'element_impression',
  linked_account_checklist_tile_impression: 'element_impression',
  location_settings_impression: 'element_impression',
  location_settings_interacted: 'element_interacted',
  manage_product_impression: 'product_impression',
  manual_asset_impression: 'element_impression',
  mark_all_notifications_as_read_interacted: 'element_interacted',
  mark_notification_as_deleted_interacted: 'element_interacted',
  mark_notification_as_read_interacted: 'element_interacted',
  mark_notification_as_undeleted_interacted: 'element_interacted',
  mark_notification_as_unread_interacted: 'element_interacted',
  marketplace_offers_impression: 'element_impression',
  marketplace_third_party_embed_impression: 'product_impression',
  maximize_page_impression: 'page_impression',
  maximize_summary_impression: 'element_impression',
  member_home_page_impression: 'page_impression',
  member_value_props_impression: 'element_impression',
  membership_enrollment_changed: 'feature_enrollment_changed',
  moment_of_delight_impression: 'element_impression',
  my_cards_impression: 'element_impression',
  native_compare_card_panel_impression: 'element_impression',
  native_marketplace_filter_impression: 'element_impression',
  navigation_item_interacted: 'element_interacted',
  nearby_deals_merchant_impression: 'element_impression',
  net_worth_account_details_impression: 'element_impression',
  net_worth_breakdown_tile_impression: 'element_impression',
  net_worth_carousel_impression: 'element_impression',
  net_worth_category_filter_impression: 'element_impression',
  net_worth_delta_tile_impression: 'element_impression',
  net_worth_history_category_impression: 'element_impression',
  net_worth_history_date_filter_impression: 'element_impression',
  net_worth_history_date_filter_interacted: 'element_interacted',
  net_worth_history_impression: 'element_impression',
  net_worth_history_interacted: 'element_interacted',
  net_worth_home_value_enrollment_changed: 'feature_enrollment_changed',
  net_worth_pending_portal_impression: 'element_impression',
  net_worth_tile_impression: 'element_impression',
  noscript_accessed: 'user_navigated',
  notification_center_element_impression: 'element_impression',
  notification_center_icon_impression: 'element_impression',
  notification_center_page_impression: 'page_impression',
  notification_enrollment_changed: 'feature_enrollment_changed',
  onboarding_interest_impression: 'element_impression',
  overlay_impression: 'impression',
  page_impression: 'toplevel_impression',
  partner_pricing_source_code_impression: 'element_impression',
  pl_pq_banner_get_started: 'element_interacted',
  pl_pq_banner_impression: 'element_impression',
  pl_prequal_all_filters_interacted: 'element_interacted',
  pl_prequal_clear_filters_interacted: 'element_interacted',
  pl_prequal_exit_popup: 'element_impression',
  pl_prequal_exit_popup_resume: 'element_interacted',
  pl_prequal_filter_interacted: 'element_interacted',
  pl_prequal_offer_compare_banner: 'element_impression',
  pl_prequal_offer_impression: 'element_impression',
  pl_prequal_preferred_lender_logo: 'element_impression',
  product_impression: 'element_impression',
  product_l2_page_category_button_impression: 'element_impression',
  profile_completion_cancel_ignore_cta_interacted: 'element_interacted',
  profile_completion_ignore_impression: 'element_impression',
  profile_completion_item_removed_impression: 'element_impression',
  profile_completion_next_item_removed_cta_interacted: 'element_interacted',
  profile_completion_no_thanks_cta_impression: 'element_impression',
  profile_completion_no_thanks_cta_interacted: 'element_interacted',
  profile_completion_yes_ignore_cta_interacted: 'element_interacted',
  pycr_enrollment_changed: 'feature_enrollment_changed',
  pycr_page_impression: 'page_impression',
  quick_win_impression: 'element_impression',
  recently_viewed_article_card_impression: 'element_impression',
  registered_user_notification_cta_interacted: 'element_interacted',
  registered_user_notification_impression: 'element_impression',
  registered_user_notification_more_interacted: 'element_interacted',
  registration_cta_impression: 'element_impression',
  results_401k_calculator_impression: 'element_impression',
  results_retirement_calculator_impression: 'element_impression',
  roundup_page_impression: 'page_impression',
  saving_page_impression: 'page_impression',
  saving_recommendations_impression: 'page_impression',
  screen_impression: 'impression',
  shopping_category_impression: 'element_impression',
  sl_prequal_offer_impression: 'element_impression',
  sl_prequal_welcome_message: 'element_impression',
  smb_cta_product_impression: 'product_impression',
  spending_page_impression: 'page_impression',
  spending_transaction_detail_impression: 'element_impression',
  table_horizontal_scroll_depth: 'element_impression',
  table_horizontal_scrolled: 'element_interacted',
  table_of_contents_item_impression: 'element_impression',
  table_of_contents_item_scrolled_into_view: 'element_interacted',
  toast_message_impression: 'overlay_impression',
  toggle_interacted: 'element_interacted',
  tooltip_impression: 'element_impression',
  top_number_error_impression: 'element_impression',
  top_number_impression: 'element_impression',
  top_spending_category_impression: 'element_impression',
  top_spending_merchant_impression: 'element_impression',
  top_takeaway_impression: 'element_impression',
  toplevel_impression: 'impression',
  transactions_date_filter_impression: 'element_impression',
  transactions_date_filter_interacted: 'element_interacted',
  transactions_spending_category_impression: 'element_impression',
  transfer_setup_page_impression: 'page_impression',
  transfer_status_page_impression: 'page_impression',
  tu_financial_account_agg_activation_value_prop_impression: 'element_impression',
  uia_insight_impression: 'element_impression',
  uia_insight_interacted: 'element_interacted',
  uia_module_impression: 'element_impression',
  undo_delete_all_notifications_interacted: 'element_interacted',
  upcoming_debt_impression: 'element_impression',
  update_notification_pin_status_interacted: 'element_interacted',
  wdmsc_stale_state_impression: 'element_impression'
};